import { render, staticRenderFns } from "./MaxStklModal.vue?vue&type=template&id=37fb8401&scoped=true&"
import script from "./MaxStklModal.vue?vue&type=script&lang=js&"
export * from "./MaxStklModal.vue?vue&type=script&lang=js&"
import style0 from "./MaxStklModal.vue?vue&type=style&index=0&id=37fb8401&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb8401",
  null
  
)

export default component.exports